type FormState = Record<string, unknown>;

type SetSecrets = (
  update: (current: Record<string, string>) => Record<string, string>,
) => void;

export async function authorizePersonalCreation(
  formState: FormState,
  getAccessToken: () => Promise<string>,
  setSecrets: SetSecrets,
): Promise<void> {
  setSecrets(function removePreviousCreationToken(current) {
    const updated = { ...current };
    delete updated.PERSONAL_GITHUB_CREATION_TOKEN;
    return updated;
  });

  if (
    formState.destination !== 'github' ||
    formState.githubAccount !== 'Flaviojcf'
  ) {
    return;
  }

  const token = await getAccessToken();
  if (!token) {
    throw new Error(
      'Autorize sua conta GitHub para criar os repositórios pessoais.',
    );
  }

  setSecrets(function storeCreationToken(current) {
    return { ...current, PERSONAL_GITHUB_CREATION_TOKEN: token };
  });
}
